let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5WL6j")).then(() => parcelRequire('3U1SG'));